import {computed, ref} from 'vue'
import {useEventListener} from '@vueuse/core'


export const useCurrentWindowScroll = () => {
    const currentScrollY = ref(0);
    const currentScrollX = ref(0);
    const isTopOfDocument = computed(() => currentScrollY.value === 0);

    const onScroll = () => {
        currentScrollY.value = window.scrollY;
        currentScrollX.value = window.scrollX;
    };

    useEventListener(window, 'scroll', onScroll);

    return {currentScrollY, currentScrollX, isTopOfDocument};
}
